export function toSortOrder(sorterOrder: string): string {
    if (sorterOrder == 'ascend') {
        return 'ASC'
    } else if (sorterOrder == 'descend') {
        return 'DESC'
    } else {
        return sorterOrder
    }
}

export function downloadBlobAsFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export function isValidNumberValue(value: any, allowZero: boolean = true): boolean {
    if (value === undefined || value === null || value === '' || !['number', 'string'].includes(typeof value)) {
        return false;
    } else {
        if (!allowZero) {
            const numberValue: number = Number(value);

            return !isNaN(numberValue) && numberValue !== 0;
        } else {
            return !isNaN(Number(value));
        }
    }
}
